module.exports = __webpack_public_path__ + "media/בננה.79e17e9c.mp3";